import { combineReducers } from "redux";
import FutureQuoteOverviewReducer from "./reducer/FutureOverview";
export default combineReducers({ FutureQuoteOverviewReducer });
